import React from 'react'
import { updatePassword } from 'aws-amplify/auth'
import FormFactory from '../../components/form_factory'
import Header from '../../components/header_home'
import WidgetIcons from '../../utils/icons'
import { Wrapper, ContainerItem, Title, ContainerForm } from './styles'
import { useAlertBox, useTabBarContext } from '../../contexts'
import { AlertBox } from '../../components/ui/layout'
import { t } from '../../adapters/translate/translate'
import { isMobile } from '../../utils/general'

const ChangePassword = () => {
  const { handleChangeTab } = useTabBarContext()
  const { alertBox, closeBox } = useAlertBox()
  const data = [
    {
      name: 'Senha',
      items: [
        {
          name: 'oldPassword',
          title: t('Current Password'),
          placeholder: ' ',
          isRequired: true,
          tabIndex: 4,
          component: 'InputPassword',
          validations: 'inputRequired',
          mb: 30,
          mt: 40
        },
        {
          name: 'password',
          title: t('New Password'),
          placeholder: ' ',
          isRequired: true,
          tabIndex: 4,
          validations: 'passwordWithMatches',
          component: 'InputPassword',
          mb: 30
        },
        {
          name: 'confirmPassword',
          title: t('Confirm New Password'),
          placeholder: ' ',
          isRequired: true,
          tabIndex: 5,
          validations: 'confirmPassword',
          component: 'InputPassword',
          hasPasswordHelp: true
        },
        {
          name: 'space',
          component: 'Space',
          mt: 0
        },
        {
          name: 'button',
          component: 'Button',
          title: t('Save'),
          submittingText: `${t('Saving')}...`
        }
      ]
    }
  ]

  const handleSubmit = async (values: any) => {
    try {
      await updatePassword({
        oldPassword: values.oldPassword,
        newPassword: values.password
      })

      alertBox(t('Password updated successfully!'), [
        {
          title: 'OK',
          action: () => {
            closeBox()
            handleChangeTab('initial')
          }
        }
      ])
    } catch (error: any) {
      alertBox(t(error?.code, error?.message))
    }
  }

  return (
    <Wrapper $isMobile={isMobile()}>
      <Header />

      <div className='container'>
        <ContainerItem>
          <WidgetIcons name="RiLockPasswordLine" size={22} />
          <Title>{t('Change Password')}</Title>
        </ContainerItem>

        <ContainerForm>
          <FormFactory data={data} onSubmit={handleSubmit} />
        </ContainerForm>
      </div>
      <AlertBox />
    </Wrapper>
  )
}

export default ChangePassword
